<iframe class="bg-white w-full h-full shadow-lg rounded-lg my-2 " [srcdoc]="report">
</iframe>